<template>
  <h1>查看课表</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/manager/components/CourseTable.vue